import { call, put, takeLatest } from 'redux-saga/effects';
import { InsuranceClaim } from '@models/InsuranceClaim';
import { Pagination } from '@models/Pagination';
import { InsuranceClaimApi } from '@apis/InsuranceClaimApi';
import { SagaPayload } from '@utils/typescript';
import { claimsFetch, ClaimsFetchPayload, stateUpdate, StateUpdatePayload } from './action';

function* handleClaimsFetch({ payload }: SagaPayload<ClaimsFetchPayload>) {
  const state: StateUpdatePayload = { claims: null, pagination: undefined };
  try {
    const [claims, pagination] = (yield call(InsuranceClaimApi.getAll, payload)) as [InsuranceClaim[], Pagination];
    state.claims = claims;
    state.pagination = pagination;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(claimsFetch, handleClaimsFetch);
}
